import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance2fuogtt2v1evi as Companion_getInstance,
  UtcOffset17lxgyhnn4rny as UtcOffset,
} from '../UtcOffset.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UtcOffsetSerializerClass;
function UtcOffsetSerializer() {
  if (UtcOffsetSerializerClass === VOID) {
    class $ {
      constructor() {
        UtcOffsetSerializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('kotlinx.datetime.UtcOffset', STRING_getInstance());
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return Companion_getInstance().parse$default_j5dbmh_k$(decoder.decodeString_x3hxsx_k$());
      }
      serialize_2fqg06_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_2fqg06_k$(encoder, value instanceof UtcOffset() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'UtcOffsetSerializer', VOID, VOID, [KSerializer()]);
    UtcOffsetSerializerClass = $;
  }
  return UtcOffsetSerializerClass;
}
var UtcOffsetSerializer_instance;
function UtcOffsetSerializer_getInstance() {
  if (UtcOffsetSerializer_instance === VOID)
    new (UtcOffsetSerializer())();
  return UtcOffsetSerializer_instance;
}
//region block: exports
export {
  UtcOffsetSerializer_getInstance as UtcOffsetSerializer_getInstance1w45h2gzvnz0q,
};
//endregion

//# sourceMappingURL=UtcOffsetSerializers.mjs.map
